import { useState, useEffect } from 'react'
import { GetStaticProps } from 'next';
import { HeadingAndText } from '../../components/content-types/omnibus/HeadingAndText'
import { ReadingOrder } from '../../components/content-types/omnibus/ReadingOrder';
import { Heading } from '../../components/content-types/omnibus/Heading';
import { CoverImage } from '../../components/content-types/omnibus/CoverImage';
import { RequiredBooks } from '../../components/content-types/omnibus/RequiredBooks';
import getOmnibus from '../../lib/getOmnibus';
import getOmnibusTitle from '../../lib/getOmnibusTitle';
import Link from 'next/link';
import Head from 'next/head';


export const getStaticPaths = async () => {
  const omnibusTitle = getOmnibusTitle()
  let paths: Array<Object> = [];

  omnibusTitle.forEach(title => {
    paths.push({
      params: { oid: title }
    })
  })

  return {
    paths: paths,
    fallback: false
  };
}

export const getStaticProps: GetStaticProps = async (context) => {
  const oid: any = context?.params?.oid
  const dataObject: any = getOmnibus(oid);

  return {
    props: {
      dataObject,
      oid
    }
  }
}

function Omnibus({ dataObject }: any) {
  function useHeadings() {
    const [headings, setHeadings]: any = useState([]);
    useEffect(() => {
      const elements: any = Array.from(document.querySelectorAll("h2, h3, h4, h5, h6"))
        .filter((element) => element.id)
        .map((element) => ({
          id: element.id,
          text: element.textContent ?? "",
          level: Number(element.tagName.substring(1))
        }));
      setHeadings(elements);
    }, []);
    return headings;
  }

  function TableOfContent() {
    const headings = useHeadings();
    return (
      <nav className='hidden lg:block'>
        <div className='fixed'>
          <header>On this page</header>
          <ul className='mt-8 my-5 border-l-2 border-l-heresy-border-default'>
            {headings.map((heading: any) => (
              <li
                key={heading.id}
                style={{ marginLeft: `${heading.level - 2}em` }}
              >
                <a href={`#${heading.id}`} className="px-4 py-6">
                  {heading.text}
                </a>
              </li>
            ))
            }
          </ul>
        </div>
      </nav>
    );
  }

  return (
    <>
    <Head>
          <title>Horus Heresy Omnibus Project - {dataObject.data['title']}</title>
          <meta name="description" content="A Fan-Created Guide for Navigating the Epic Series" />
          <link rel="icon" href="/favicon.ico" />
        </Head>
    
    <main>
      <div className='flex flex-col'>
        <div className='bg-black'>
          {dataObject.data['cover-image'] && <CoverImage imagePath={dataObject.data['cover-image']} />}
        </div>
        <div className='p-4 ml-auto mr-auto flex lg:flex-row'>
          <div className=''>
            {dataObject.data['story'] && <HeadingAndText heading={'The Story'} text={dataObject.data['story']} />}
            {dataObject.data['reading-order'] && <ReadingOrder data={dataObject.data['reading-order']} note={dataObject.data['reading-order-note']} />}
            {dataObject.data['reading-order-reason'] && <HeadingAndText heading={'Why this Reading Order?'} text={dataObject.data['reading-order-reason']} />}
            {dataObject.data['primarchs-section'] && <HeadingAndText heading={'Additions from \'The Primarchs\' & \'Horus Heresy Characters\''} text={dataObject.data['primarchs-section']} />}
            {dataObject.data['req-recommended-reading'] && <HeadingAndText heading={'Required and Recommended Reading'} text={dataObject.data['req-recommended-reading']} />}
            {dataObject.data['follow-up'] && <HeadingAndText heading={'Follow-Up'} text={dataObject.data['follow-up']} />}
            {dataObject.data['req-books'] && <RequiredBooks data={dataObject.data['req-books']} note={dataObject.data['req-books-note']} />}
            {dataObject.data['beyond-heresy'] && <HeadingAndText heading={'Beyond the Heresy'} text={dataObject.data['beyond-heresy']} />}
          </div>
          {/* <TableOfContent /> */}
        </div>
      </div>
    </main>
    </>
  )
}

export default Omnibus
